
import React, { Component } from 'react'
// import { Form, Field } from 'react-final-form'
import { Input} from '@progress/kendo-react-inputs'
import { Error } from '@progress/kendo-react-labels';
import { Form, Field, FormElement } from '@progress/kendo-react-form';

export default function UiInput(props) {
    const {
        validationMessage,
        label,
        visited,
        placeholder,
        disabled,
        ...others
      } = props;


    return (   
                  <>
                        <label className='sba-telerik-label'>{label}</label>
                        <Input
                            {...others}
                            placeholder={placeholder}
                            disabled={disabled}
                        />
                        {visited && validationMessage && <Error>{validationMessage}</Error>}

                        
                    </>
                )
            
}


// import React, { Component } from 'react'
// import { Form, Field } from 'react-final-form'
// import { Input} from '@progress/kendo-react-inputs'

// export default function UiInput(props) {
//     const { label, name, placeholder } = props;

//     return (

//         <Field
//             name={name}
//             render={({ input, meta, ...rest }) => {
//                 return (
//                     <>
//                         <label className='sba-telerik-label'>{label}</label>
//                         <Input
//                             {...input}
//                             {...rest}
//                             placeholder={placeholder}
//                         />
                        
//                         {meta.error && <span className="k-required">{meta.error}</span>}
//                     </>
//                 )
//             }}
//         />
//     )

// }


